<template>
    <div
        @click="enter(item)"
        @mouseover="mouseOver(index)"
        @mouseout="mouseOut"
        class="searchSection__item"
        :class="{
            'is-active': index === counter,
            'no-hover': index !== -1 && index !== counter,
            'is-disabled': starting,
            'is-disabled-block': checkRequestInboxAccess
        }"
    >
        <div class="searchSection__info">
            <avatar :size="32" :contact="item"/>
            <div class="searchSection__details">
                <span v-if="item.full_name">
                    <div class="searchSection__fullName">{{ item.full_name }}</div>
                </span>
                <em v-else>No Name</em>
                <div class="searchSection__details-items">
                    <span
                        v-if="item.phoneInfo"
                        class="searchSection__number"
                    >
                        <text-highlight :queries="keywords">{{ item.phoneInfo }}</text-highlight>
                    </span>
                    <span
                        v-if="item.email"
                        class="searchSection__email"
                    >
                        <text-highlight :queries="keywords">{{ item.email }}</text-highlight>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextHighlight from 'vue-word-highlighter';
import InitialsMixin from '../../../../mixins/initials.js';
import UserMixin from '../../../../mixins/user';

export default {
    components: {
        TextHighlight,
    },

    mixins: [
        InitialsMixin,
        UserMixin,
    ],

    props: [
        'item',
        'counter',
        'starting',
        'index',
        'querySearch',
        'hasSearchAll',
    ],

    computed: {
        keywords() {
            if (!this.querySearch) return [];

            return this.querySearch.split(' ');
        },
    },

    methods: {
        start(e, contact) {
            e.stopPropagation();

            this.$emit('start', contact);
        },

        enter(contact) {
            this.$emit('enter', contact, 'contact', 'Contact');
        },

        mouseOver(i) {
            this.$emit('mouseOver', i);
        },

        mouseOut() {
            this.$emit('mouseOut');
        }
    },
};
</script>
